// extracted by mini-css-extract-plugin
export var navbarItem = "navbar-mobile-module--navbar-item--ZuaCL";
export var navbarItemActive = "navbar-mobile-module--navbar-item-active--VpxxG";